import script from "./EditCryptoCurrency.vue?vue&type=script&setup=true&lang=js"
export * from "./EditCryptoCurrency.vue?vue&type=script&setup=true&lang=js"

import "./EditCryptoCurrency.vue?vue&type=style&index=0&id=539a858b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/payments-cmglobals/payments-cmglobals/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-539a858b"]])

export default __exports__